var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('veeno',_vm._g({attrs:{"connect":"","tooltips":_vm.tooltips(),"step":1,"range":_vm.range,"handles":_vm.value},on:{"set":_vm.set}},_vm.inputListeners))}
var staticRenderFns = []

export { render, staticRenderFns }